/* globals $ */

'use strict';

var ajaxSearch;
function search(focusResults) {
  var rawQuery = $('#fund-search-input').val();
  var query = encodeURI(rawQuery);
  var searchContainer = $('#search-item-container');
  var searchResultSummary = $('#search-result-summary');
  var defaultContainer = $('#default-item-container');

  if (query === undefined || query === '') {
    searchResultSummary.empty();
    searchContainer.hide();
    defaultContainer.show();
  } else {
    if (ajaxSearch) {
      ajaxSearch.abort();
    }

    $('#search-spinner').css('opacity', '1');

    ajaxSearch = $.ajax({
      type: 'GET',
      url: '/fonder/search?q=' + query,
      contentType: 'application/json',
    })
      .done(function (response) {
        $('#search-spinner').css('opacity', '0');
        searchContainer.empty();
        searchContainer.show();
        defaultContainer.hide();

        if (response.length === 0) {
          searchResultSummary.text('Inga resultat.');
          searchContainer.append(
            '<div class="no-results"><p>Inga resultat</p></div>',
          );
          return;
        }

        // Define a regexp for marking all query substrings in the search
        // result. We must regexp escape the query before using it as part
        // of the expression. The raw query "foo bar$ ba/z" becomes the
        // regexp /(foo|bar\$|ba\/z)/ig.
        var queryRE = new RegExp(
          '(' +
            rawQuery
              .trim()
              .split(/\s+/g)
              .reduce(function (re, q) {
                return re + '|' + q.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
              }) +
            ')',
          'ig',
        );

        var resultNames = response.map(function (item) {
          return item.name;
        });
        searchResultSummary.text(
          resultNames.length +
            (resultNames.length === 1
              ? ' fond hittades: '
              : ' fonder hittades: ') +
            resultNames.join(', ') +
            '.',
        );

        response.forEach(function (item) {
          var name = item.name.replace(queryRE, '<mark>$&</mark>');
          searchContainer.append(
            '<a href="/' +
              item.link +
              '">' +
              '<div class="item"><span class="item-name fund">' +
              name +
              '</span>' +
              '<span class="icon-right-arrow"></span></div></a>',
          );
        });

        if (focusResults) {
          searchContainer.trigger('focus');
        }
      })
      .fail(function (error) {
        $('#search-spinner').css('opacity', '0');
        if (error.statusText !== 'abort') {
          console.error('error on search fund', error);
        }
      });
  }
}

$(function () {
  search();
  var timer;
  $('#fund-search-form').on('submit', function (event) {
    event.preventDefault();
    search(true);
  });
  $('#fund-search-input').on('input', function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      search();
    }, 150);
  });
});
